// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"30215ed6","743":"3ae7d744","917":"2f9ddc5a"}[chunkId] + ".chunk.js";
};